import WebFont from 'webfontloader';
import _ from 'lodash';

const {fontList} = window.___editorData;
const fontsToLoad = {};
let availableFonts = {};

fontList.forEach((font) => {
  fontsToLoad[_.trim(font)] = true;
});

let attempts = 0;

function start() {
  if (!_.isEmpty(fontsToLoad)) {
    attempts++;
    if (attempts < 5) {
      let maxIndex = 0;
      console.log(`Attempting to load ${_.size(fontsToLoad)} fonts`);
      _.keys(fontsToLoad).forEach((font, index) => {
        setTimeout(WebFont.load({
          google: {
            families: [font],
          },
          fontactive: (font) => {
            delete fontsToLoad[font];
            availableFonts = {...availableFonts};
            availableFonts[font] = true;
          },
          timeout: 4500
        }), index * 50);
        maxIndex = index;
      });
      setTimeout(start, 5000 + (maxIndex * 50));
    } else {
      console.log('Failed to load the following fonts:', _.keys(fontsToLoad));
    }

  }
}

let sortedFontList = null;
let lastAbailableFont = null;
function getAvailableFonts() {
  if (lastAbailableFont !== availableFonts) {
    sortedFontList = _.sortBy(_.keys(availableFonts));
    lastAbailableFont = availableFonts;
  }
  return sortedFontList;
}

window.___ckeditorGetAvailableFont = getAvailableFonts;

export default {
  start,
  getAvailableFonts,
};
